import { FC, useState } from 'react';
import { useTrans } from 'base/utils/i18n';
import { OptionBtn } from '@pro/420CheckIn/Interactive/OptionBtn';
import LoginModal from '@app/common/LoginModal';
import { ICheckInInstance } from 'mod/checkIn/useCheckIn';
import { IconLoading } from '@base/icon';
import useLogin from 'base/utils/useLogin';

type IProps = {
    onCheckIn: ICheckInInstance['onCheckIn'];
};

export const OptionCheckIn: FC<IProps> = props => {
    const { onCheckIn } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const { loginModalProps, checkAuth } = useLogin();
    const { t } = useTrans();

    const checkIn = async () => {
        setLoading(true);
        await onCheckIn();
        setLoading(false);
    };

    return (
        <>
            <OptionBtn
                disabled={loading}
                onClick={() => checkAuth(checkIn)}
            >
                {loading
                    ? <IconLoading size={24}/>
                    : <strong>{t('web_common_btn_check_in_upper')}</strong>}
            </OptionBtn>

            <LoginModal
                {...loginModalProps}
                onLoginSuccess={checkIn}
            />
        </>
    )
};
